import CustomDataArea from './CustomDataArea';

const AblogCustomData = ({ customData }) => {
  return <CustomDataArea customData={customData} />;
};

export default AblogCustomData;
